import {
  MODIFY_ACCESS,
  NEW_ACCESS,
  RequestResponse,
  REVOKE_ACCESS,
} from "@api";
import { Form, Modal } from "@components";
import { Box, Button } from "@material-ui/core";
import React, { useCallback } from "react";
import { RowWrapper } from "../../types";
import { Filters } from "./types";
import { filloutDropdowns } from "./utils";
import { Manager } from "@components/form/state/types";

interface Props {
  requests: RowWrapper<RequestResponse>[];
  open: boolean;
  onCancel: () => void;
  onApply: (filter: any) => void;
  form: Manager<Filters>;
}

type Key = keyof Filters;

export const SystemAppNameFilters: React.FC<Props> = ({
  requests,
  open,
  onCancel,
  onApply,
  form,
}) => {
  const {
    environments,
    systemNames,
    statuses,
    systemCategories,
    systemTypes,
  } = filloutDropdowns(requests, true);

  // console.log(systemTypes);

  const handleSubmit = useCallback(() => {
    onApply(form.values);
  }, [form.values, onApply]);

  function onChange(name: Key, value: any): void {
    // [TODO] check types
    form.set(Form.target.VALUE, [name, value]);
  }

  return (
    <Modal isOpen={open} title="Search Filter" closeModal={onCancel}>
      <Form>
        <Form.Dropdown
          label="Business Unit"
          onChange={onChange}
          options={[{ label: "No Selection", value: "" }, ...systemTypes]}
          name="systemType"
          size={12}
          error={form.errors.systemType}
          value={form.values.systemType || ""}
        />
      </Form>
      <Box textAlign="right" mt={4}>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={handleSubmit}
          style={{ marginLeft: "40px" }}
        >
          Apply
        </Button>
      </Box>
    </Modal>
  );
};
